module.exports = __webpack_public_path__ + "static/analysis2-0ec85fa29cfdb428a02a5da1e7d72e05.jpg";